import {
  webFrameTemplate,
  cryptoFrameTemplate,
  balanceFrameTemplate,
  tickerFrameTemplate,
  nflTeamLeadersFrameTemplate,
  nflTeamStatsFrameTemplate,
  nflStandingsFrameTemplate,
  nflLeadersFrameTempalate,
  tweetFrameTemplate,
  spotifyPodcastFrameTemplate,
  twitterProfileFrameTemplate,
  nflTickerFrameTemplate,
} from '~/data/dataframes'
import { defaultTokens as defaultTickerTokens } from '~/utils/helpers'

// https://www.notion.so/eboweb3/90c548ec5ceb4c3ca3d15440d07a23dc
const datasetTemplates = [
  {
    objectID: 'T0001',
    subtitle: 'Embedded Website',
    frames: [webFrameTemplate({ width: 800, height: 450 }, 'https://bleacherreport.com/')],
  },
  {
    objectID: 'T0010',
    frames: [
      nflTeamLeadersFrameTemplate({ x: 0, y: 0 }, 19, 'Miami Dolphins'),
      tweetFrameTemplate({ x: 1341, y: 17 }),
      spotifyPodcastFrameTemplate({ x: 972, y: 177 }, 'https://open.spotify.com/show/4ejYGtMsSxSfu8vxloULFe'),
      spotifyPodcastFrameTemplate({ x: 972, y: 405 }, 'https://open.spotify.com/show/1h5AvikBOVYhqtI7zuuUU7'),
      cryptoFrameTemplate({ x: 1005, y: 753 }, 'sm', 'BTC'),
      cryptoFrameTemplate({ x: 1135, y: 753 }, 'sm', 'ETH'),
      balanceFrameTemplate({ x: 1265, y: 753 }, 'sm'),
    ],
  },
  {
    objectID: 'T0011',
    frames: [
      webFrameTemplate({ width: 800, height: 450 }, 'https://bleacherreport.com/'),
      twitterProfileFrameTemplate({ x: 420, y: 0 }, 'NFL', { size: 'sm' }),
      tweetFrameTemplate({ x: 1319, y: 46 }),
      nflTickerFrameTemplate({ x: 0, y: 664 }),
    ],
  },
  {
    objectID: 'T0012',
    frames: [
      spotifyPodcastFrameTemplate({ x: 122, y: 97 }, 'https://open.spotify.com/show/3mHmg20i5kAHCqVoyYZCOg'),
      spotifyPodcastFrameTemplate({ x: 122, y: 329 }, 'https://open.spotify.com/show/6iF7cYu0JmmHns3t8dKz93'),
      spotifyPodcastFrameTemplate({ x: 122, y: 561 }, 'https://open.spotify.com/show/5EUwkOeRCincWU0ViOWVvH'),
      twitterProfileFrameTemplate({ x: 700, y: 0 }, 'ESPNNFL'),
      tweetFrameTemplate({ x: 1329, y: 30 }),
    ],
  },
  {
    objectID: 'T0013',
    frames: [
      webFrameTemplate({ width: 800, height: 450 }, 'https://bleacherreport.com/'),
      nflStandingsFrameTemplate({ x: 142, y: 0 }),
      spotifyPodcastFrameTemplate({ x: 974, y: 10 }, 'https://open.spotify.com/show/3lio8WMfDBCklvTaBGZcvq'),
      spotifyPodcastFrameTemplate({ x: 974, y: 202 }, 'https://open.spotify.com/show/1PwO8ajcCP9L43Nimdb38n'),
    ],
  },
  {
    objectID: 'T0014',
    frames: [
      spotifyPodcastFrameTemplate({ x: 10, y: 117 }, 'https://open.spotify.com/show/4tbRVZn6sFJetPW3ZYGgfF'),
      spotifyPodcastFrameTemplate({ x: 10, y: 329 }, 'https://open.spotify.com/show/2pUKE9ryelnB7W0h07Gztm'),
      spotifyPodcastFrameTemplate({ x: 10, y: 541 }, 'https://open.spotify.com/show/5kIqaaV0Cm9CCfncy0ocS0'),
      nflTeamStatsFrameTemplate({ x: 470, y: 0 }, 11, 'Detroit Lions'),
    ],
  },
  {
    objectID: 'T0015',
    frames: [
      spotifyPodcastFrameTemplate({ x: 0, y: 63 }, 'https://open.spotify.com/show/4JyHuFSlEtjs7wzPhp0Lx0'),
      spotifyPodcastFrameTemplate({ x: 0, y: 240 }, 'https://open.spotify.com/show/1ol0jP8hrNHydiAd38G6B1'),
      spotifyPodcastFrameTemplate({ x: 0, y: 417 }, 'https://open.spotify.com/show/659pdH7WFYgHMUuyg2MTBe'),
      spotifyPodcastFrameTemplate({ x: 0, y: 594 }, 'https://open.spotify.com/show/68aiUbds0w0TAhdqMRTdS1'),
      nflLeadersFrameTempalate({ x: 470, y: 0 }),
    ],
  },
  {
    objectID: 'T0101',
    frames: [
      balanceFrameTemplate({ x: 301, y: 670 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 670 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 879, y: 670 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0102',
    frames: [
      balanceFrameTemplate({ x: 301, y: 20 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 20 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 879, y: 20 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0103',
    frames: [
      balanceFrameTemplate({ x: 301, y: 375 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 375 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 879, y: 375 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0104',
    frames: [
      balanceFrameTemplate({ x: 20, y: 20 }, 'lg'),
      cryptoFrameTemplate({ x: 20, y: 110 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 200 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0105',
    frames: [
      balanceFrameTemplate({ x: 20, y: 490 }, 'lg'),
      cryptoFrameTemplate({ x: 20, y: 580 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 670 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0106',
    frames: [
      balanceFrameTemplate({ x: 20, y: 285 }, 'lg'),
      cryptoFrameTemplate({ x: 20, y: 375 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 465 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0107',
    frames: [
      balanceFrameTemplate({ x: 590, y: 20 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 110 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 200 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0108',
    frames: [
      balanceFrameTemplate({ x: 590, y: 285 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 375 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 465 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0109',
    frames: [
      balanceFrameTemplate({ x: 590, y: 490 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 580 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 670 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0110',
    frames: [
      balanceFrameTemplate({ x: 331, y: 420 }, 'lg'),
      cryptoFrameTemplate({ x: 590, y: 330 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 849, y: 420 }, 'lg', 'BTC'),
    ],
  },
  {
    objectID: 'T0111',
    frames: [
      balanceFrameTemplate({ x: 366, y: 670 }, 'sm'),
      cryptoFrameTemplate({ x: 655, y: 670 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 945, y: 670 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0112',
    frames: [
      balanceFrameTemplate({ x: 366, y: 20 }, 'sm'),
      cryptoFrameTemplate({ x: 655, y: 20 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 945, y: 20 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0113',
    frames: [
      balanceFrameTemplate({ x: 366, y: 375 }, 'sm'),
      cryptoFrameTemplate({ x: 655, y: 375 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 945, y: 375 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0114',
    frames: [
      balanceFrameTemplate({ x: 20, y: 20 }, 'sm'),
      cryptoFrameTemplate({ x: 20, y: 110 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 200 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0115',
    frames: [
      balanceFrameTemplate({ x: 20, y: 490 }, 'sm'),
      cryptoFrameTemplate({ x: 20, y: 580 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 670 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0116',
    frames: [
      balanceFrameTemplate({ x: 20, y: 285 }, 'sm'),
      cryptoFrameTemplate({ x: 20, y: 375 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 465 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0117',
    frames: [
      balanceFrameTemplate({ x: 655, y: 20 }, 'sm'),
      cryptoFrameTemplate({ x: 655, y: 110 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 655, y: 200 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0118',
    frames: [
      balanceFrameTemplate({ x: 655, y: 285 }, 'sm'),
      cryptoFrameTemplate({ x: 655, y: 375 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 655, y: 465 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0119',
    frames: [
      balanceFrameTemplate({ x: 655, y: 490 }, 'sm'),
      cryptoFrameTemplate({ x: 655, y: 580 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 655, y: 670 }, 'sm', 'BTC'),
    ],
  },
  {
    objectID: 'T0120',
    frames: [
      balanceFrameTemplate({ x: 525, y: 385 }, 'md'),
      cryptoFrameTemplate({ x: 655, y: 325 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 785, y: 385 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0121',
    frames: [
      balanceFrameTemplate({ x: 641, y: 352 }, 'md'),
      cryptoFrameTemplate({ x: 641, y: 387 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 641, y: 422 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0122',
    frames: [
      balanceFrameTemplate({ x: 641, y: 19 }, 'md'),
      cryptoFrameTemplate({ x: 641, y: 54 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 641, y: 89 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0123',
    frames: [
      balanceFrameTemplate({ x: 20, y: 352 }, 'md'),
      cryptoFrameTemplate({ x: 20, y: 387 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 422 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0124',
    frames: [
      balanceFrameTemplate({ x: 641, y: 625 }, 'md'),
      cryptoFrameTemplate({ x: 641, y: 660 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 641, y: 695 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0125',
    frames: [
      balanceFrameTemplate({ x: 1263, y: 352 }, 'md'),
      cryptoFrameTemplate({ x: 1263, y: 387 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 1263, y: 422 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0126',
    frames: [
      balanceFrameTemplate({ x: 20, y: 19 }, 'md'),
      cryptoFrameTemplate({ x: 20, y: 54 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 89 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0127',
    frames: [
      balanceFrameTemplate({ x: 20, y: 625 }, 'md'),
      cryptoFrameTemplate({ x: 20, y: 660 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 20, y: 695 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0128',
    frames: [
      balanceFrameTemplate({ x: 1263, y: 625 }, 'md'),
      cryptoFrameTemplate({ x: 1263, y: 660 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 1263, y: 695 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0129',
    frames: [
      balanceFrameTemplate({ x: 1263, y: 19 }, 'md'),
      cryptoFrameTemplate({ x: 1263, y: 54 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 1263, y: 89 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0130',
    frames: [
      balanceFrameTemplate({ x: 220, y: 79 }, 'md'),
      cryptoFrameTemplate({ x: 220, y: 114 }, 'md', 'ETH'),
      cryptoFrameTemplate({ x: 220, y: 149 }, 'md', 'BTC'),
    ],
  },
  {
    objectID: 'T0131',
    subtitle: 'Token Ticker full speed buy link',
    frames: [tickerFrameTemplate({ x: 0, y: 375 }, defaultTickerTokens, 'lg', 'full')],
  },
  {
    objectID: 'T0132',
    subtitle: 'Token Ticker full speed small symbol buy link',
    frames: [tickerFrameTemplate({ x: 0, y: 387 }, defaultTickerTokens, 'sm', 'full')],
  },
  {
    objectID: 'T0135',
    subtitle: 'Token Icons Ticker full speed large symbol buy link',
    frames: [tickerFrameTemplate({ x: 0, y: 375 }, defaultTickerTokens, 'lg', 'full', true)],
  },
  {
    objectID: 'T0136',
    subtitle: 'Token Icons Ticker full speed small symbol buy link',
    frames: [tickerFrameTemplate({ x: 0, y: 387 }, defaultTickerTokens, 'sm', 'full', true)],
  },
  {
    objectID: 'T0141',
    subtitle: 'Token Price large symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 278, y: 151 }, 'lg', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 151 }, 'lg', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 151 }, 'lg', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 241 }, 'lg', 'AAVE', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 241 }, 'lg', 'BAT', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 241 }, 'lg', 'LINK', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 331 }, 'lg', 'COMP', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 331 }, 'lg', 'CRV', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 331 }, 'lg', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 418 }, 'lg', 'SNX', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 418 }, 'lg', 'UMA', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 418 }, 'lg', 'YFI', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 508 }, 'lg', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 508 }, 'lg', 'RAI', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 508 }, 'lg', 'USDC', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 598 }, 'lg', 'USDT', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 598 }, 'lg', 'GUSD', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 598 }, 'lg', 'PAX', { symbol: true }),
    ],
  },
  {
    objectID: 'T0142',
    subtitle: 'Token Price small symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 462, y: 165 }, 'sm', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 165 }, 'sm', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 165 }, 'sm', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 255 }, 'sm', 'AAVE', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 255 }, 'sm', 'BAT', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 255 }, 'sm', 'LINK', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 345 }, 'sm', 'COMP', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 345 }, 'sm', 'CRV', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 345 }, 'sm', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 435 }, 'sm', 'SNX', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 435 }, 'sm', 'UMA', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 435 }, 'sm', 'YFI', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 525 }, 'sm', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 525 }, 'sm', 'RAI', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 525 }, 'sm', 'USDC', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 615 }, 'sm', 'USDT', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 615 }, 'sm', 'GUSD', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 615 }, 'sm', 'PAX', { symbol: true }),
    ],
  },
  {
    objectID: 'T0143',
    subtitle: 'Token Price large name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 278, y: 151 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 151 }, 'lg', 'WBTC'),
      cryptoFrameTemplate({ x: 902, y: 151 }, 'lg', 'UNI'),
      cryptoFrameTemplate({ x: 278, y: 241 }, 'lg', 'AAVE'),
      cryptoFrameTemplate({ x: 590, y: 241 }, 'lg', 'BAT'),
      cryptoFrameTemplate({ x: 902, y: 241 }, 'lg', 'LINK'),
      cryptoFrameTemplate({ x: 278, y: 331 }, 'lg', 'COMP'),
      cryptoFrameTemplate({ x: 590, y: 331 }, 'lg', 'CRV'),
      cryptoFrameTemplate({ x: 902, y: 331 }, 'lg', 'MKR'),
      cryptoFrameTemplate({ x: 278, y: 418 }, 'lg', 'SNX'),
      cryptoFrameTemplate({ x: 590, y: 418 }, 'lg', 'UMA'),
      cryptoFrameTemplate({ x: 902, y: 418 }, 'lg', 'YFI'),
      cryptoFrameTemplate({ x: 278, y: 508 }, 'lg', 'DAI'),
      cryptoFrameTemplate({ x: 590, y: 508 }, 'lg', 'RAI'),
      cryptoFrameTemplate({ x: 902, y: 508 }, 'lg', 'USDC'),
      cryptoFrameTemplate({ x: 278, y: 598 }, 'lg', 'USDT'),
      cryptoFrameTemplate({ x: 590, y: 598 }, 'lg', 'GUSD'),
      cryptoFrameTemplate({ x: 902, y: 598 }, 'lg', 'PAX'),
    ],
  },
  {
    objectID: 'T0144',
    subtitle: 'Token Price small name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 462, y: 165 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 655, y: 165 }, 'sm', 'WBTC'),
      cryptoFrameTemplate({ x: 848, y: 165 }, 'sm', 'UNI'),
      cryptoFrameTemplate({ x: 462, y: 255 }, 'sm', 'AAVE'),
      cryptoFrameTemplate({ x: 655, y: 255 }, 'sm', 'BAT'),
      cryptoFrameTemplate({ x: 848, y: 255 }, 'sm', 'LINK'),
      cryptoFrameTemplate({ x: 462, y: 345 }, 'sm', 'COMP'),
      cryptoFrameTemplate({ x: 655, y: 345 }, 'sm', 'CRV'),
      cryptoFrameTemplate({ x: 848, y: 345 }, 'sm', 'MKR'),
      cryptoFrameTemplate({ x: 462, y: 435 }, 'sm', 'SNX'),
      cryptoFrameTemplate({ x: 655, y: 435 }, 'sm', 'UMA'),
      cryptoFrameTemplate({ x: 848, y: 435 }, 'sm', 'YFI'),
      cryptoFrameTemplate({ x: 462, y: 525 }, 'sm', 'DAI'),
      cryptoFrameTemplate({ x: 655, y: 525 }, 'sm', 'RAI'),
      cryptoFrameTemplate({ x: 848, y: 525 }, 'sm', 'USDC'),
      cryptoFrameTemplate({ x: 462, y: 615 }, 'sm', 'USDT'),
      cryptoFrameTemplate({ x: 655, y: 615 }, 'sm', 'GUSD'),
      cryptoFrameTemplate({ x: 848, y: 615 }, 'sm', 'PAX'),
    ],
  },
  {
    objectID: 'T0145',
    subtitle: 'Token Price large symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 278, y: 151 }, 'lg', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 151 }, 'lg', 'BTC', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 151 }, 'lg', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 241 }, 'lg', 'AAVE', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 241 }, 'lg', 'DOGE', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 241 }, 'lg', 'DOT', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 331 }, 'lg', 'COMP', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 331 }, 'lg', 'MATIC', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 331 }, 'lg', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 418 }, 'lg', 'SNX', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 418 }, 'lg', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 418 }, 'lg', 'ATOM', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 508 }, 'lg', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 508 }, 'lg', 'APE', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 508 }, 'lg', 'XTZ', { symbol: true }),
      cryptoFrameTemplate({ x: 278, y: 598 }, 'lg', 'GRT', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 598 }, 'lg', 'ENJ', { symbol: true }),
      cryptoFrameTemplate({ x: 902, y: 598 }, 'lg', 'ENS', { symbol: true }),
    ],
  },
  {
    objectID: 'T0146',
    subtitle: 'Token Price small symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 462, y: 165 }, 'sm', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 165 }, 'sm', 'BTC', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 165 }, 'sm', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 255 }, 'sm', 'AAVE', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 255 }, 'sm', 'DOGE', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 255 }, 'sm', 'DOT', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 345 }, 'sm', 'COMP', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 345 }, 'sm', 'MATIC', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 345 }, 'sm', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 435 }, 'sm', 'SNX', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 435 }, 'sm', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 435 }, 'sm', 'ATOM', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 525 }, 'sm', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 525 }, 'sm', 'APE', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 525 }, 'sm', 'XTZ', { symbol: true }),
      cryptoFrameTemplate({ x: 462, y: 615 }, 'sm', 'GRT', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 615 }, 'sm', 'ENJ', { symbol: true }),
      cryptoFrameTemplate({ x: 848, y: 615 }, 'sm', 'ENS', { symbol: true }),
    ],
  },
  {
    objectID: 'T0147',
    subtitle: 'Token Price large name % change',
    frames: [
      cryptoFrameTemplate({ x: 278, y: 151 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 151 }, 'lg', 'BTC'),
      cryptoFrameTemplate({ x: 902, y: 151 }, 'lg', 'UNI'),
      cryptoFrameTemplate({ x: 278, y: 241 }, 'lg', 'AAVE'),
      cryptoFrameTemplate({ x: 590, y: 241 }, 'lg', 'DOGE'),
      cryptoFrameTemplate({ x: 902, y: 241 }, 'lg', 'DOT'),
      cryptoFrameTemplate({ x: 278, y: 331 }, 'lg', 'COMP'),
      cryptoFrameTemplate({ x: 590, y: 331 }, 'lg', 'MATIC'),
      cryptoFrameTemplate({ x: 902, y: 331 }, 'lg', 'MKR'),
      cryptoFrameTemplate({ x: 278, y: 418 }, 'lg', 'SNX'),
      cryptoFrameTemplate({ x: 590, y: 418 }, 'lg', 'WBTC'),
      cryptoFrameTemplate({ x: 902, y: 418 }, 'lg', 'ATOM'),
      cryptoFrameTemplate({ x: 278, y: 508 }, 'lg', 'DAI'),
      cryptoFrameTemplate({ x: 590, y: 508 }, 'lg', 'APE'),
      cryptoFrameTemplate({ x: 902, y: 508 }, 'lg', 'XTZ'),
      cryptoFrameTemplate({ x: 278, y: 598 }, 'lg', 'GRT'),
      cryptoFrameTemplate({ x: 590, y: 598 }, 'lg', 'ENJ'),
      cryptoFrameTemplate({ x: 902, y: 598 }, 'lg', 'ENS'),
    ],
  },
  {
    objectID: 'T0148',
    subtitle: 'Token Price small name % change',
    frames: [
      cryptoFrameTemplate({ x: 462, y: 165 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 655, y: 165 }, 'sm', 'BTC'),
      cryptoFrameTemplate({ x: 848, y: 165 }, 'sm', 'UNI'),
      cryptoFrameTemplate({ x: 462, y: 255 }, 'sm', 'AAVE'),
      cryptoFrameTemplate({ x: 655, y: 255 }, 'sm', 'DOGE'),
      cryptoFrameTemplate({ x: 848, y: 255 }, 'sm', 'DOT'),
      cryptoFrameTemplate({ x: 462, y: 345 }, 'sm', 'COMP'),
      cryptoFrameTemplate({ x: 655, y: 345 }, 'sm', 'MATIC'),
      cryptoFrameTemplate({ x: 848, y: 345 }, 'sm', 'MKR'),
      cryptoFrameTemplate({ x: 462, y: 435 }, 'sm', 'SNX'),
      cryptoFrameTemplate({ x: 655, y: 435 }, 'sm', 'WBTC'),
      cryptoFrameTemplate({ x: 848, y: 435 }, 'sm', 'ATOM'),
      cryptoFrameTemplate({ x: 462, y: 525 }, 'sm', 'DAI'),
      cryptoFrameTemplate({ x: 655, y: 525 }, 'sm', 'APE'),
      cryptoFrameTemplate({ x: 848, y: 525 }, 'sm', 'XTZ'),
      cryptoFrameTemplate({ x: 462, y: 615 }, 'sm', 'GRT'),
      cryptoFrameTemplate({ x: 655, y: 615 }, 'sm', 'ENJ'),
      cryptoFrameTemplate({ x: 848, y: 615 }, 'sm', 'ENS'),
    ],
  },
  {
    objectID: 'T0149',
    subtitle: 'Token Price large symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 590, y: 150 }, 'lg', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 240 }, 'lg', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 330 }, 'lg', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 420 }, 'lg', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 510 }, 'lg', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 600 }, 'lg', 'USDC', { symbol: true }),
    ],
  },
  {
    objectID: 'T0150',
    subtitle: 'Token Price small symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 655, y: 165 }, 'sm', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 255 }, 'sm', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 345 }, 'sm', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 435 }, 'sm', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 525 }, 'sm', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 655, y: 615 }, 'sm', 'USDC', { symbol: true }),
    ],
  },
  {
    objectID: 'T0151',
    subtitle: 'Token Price large name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 590, y: 150 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 240 }, 'lg', 'WBTC'),
      cryptoFrameTemplate({ x: 590, y: 330 }, 'lg', 'UNI'),
      cryptoFrameTemplate({ x: 590, y: 420 }, 'lg', 'MKR'),
      cryptoFrameTemplate({ x: 590, y: 510 }, 'lg', 'DAI'),
      cryptoFrameTemplate({ x: 590, y: 600 }, 'lg', 'USDC'),
    ],
  },
  {
    objectID: 'T0152',
    subtitle: 'Token Price small name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 654, y: 165 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 654, y: 255 }, 'sm', 'WBTC'),
      cryptoFrameTemplate({ x: 654, y: 345 }, 'sm', 'UNI'),
      cryptoFrameTemplate({ x: 654, y: 435 }, 'sm', 'MKR'),
      cryptoFrameTemplate({ x: 654, y: 525 }, 'sm', 'DAI'),
      cryptoFrameTemplate({ x: 654, y: 615 }, 'sm', 'USDC'),
    ],
  },
  {
    objectID: 'T0153',
    subtitle: 'Token Price large symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 590, y: 150 }, 'lg', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 240 }, 'lg', 'BTC', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 330 }, 'lg', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 420 }, 'lg', 'DOT', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 510 }, 'lg', 'XTZ', { symbol: true }),
      cryptoFrameTemplate({ x: 590, y: 600 }, 'lg', 'APE', { symbol: true }),
    ],
  },
  {
    objectID: 'T0154',
    subtitle: 'Token Price small symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 654, y: 165 }, 'sm', 'ETH', { symbol: true }),
      cryptoFrameTemplate({ x: 654, y: 255 }, 'sm', 'WBTC', { symbol: true }),
      cryptoFrameTemplate({ x: 654, y: 345 }, 'sm', 'UNI', { symbol: true }),
      cryptoFrameTemplate({ x: 654, y: 435 }, 'sm', 'MKR', { symbol: true }),
      cryptoFrameTemplate({ x: 654, y: 525 }, 'sm', 'DAI', { symbol: true }),
      cryptoFrameTemplate({ x: 654, y: 615 }, 'sm', 'USDC', { symbol: true }),
    ],
  },
  {
    objectID: 'T0155',
    subtitle: 'Token Price large name % change',
    frames: [
      cryptoFrameTemplate({ x: 590, y: 150 }, 'lg', 'ETH'),
      cryptoFrameTemplate({ x: 590, y: 240 }, 'lg', 'BTC'),
      cryptoFrameTemplate({ x: 590, y: 330 }, 'lg', 'UNI'),
      cryptoFrameTemplate({ x: 590, y: 420 }, 'lg', 'DOT'),
      cryptoFrameTemplate({ x: 590, y: 510 }, 'lg', 'XTZ'),
      cryptoFrameTemplate({ x: 590, y: 600 }, 'lg', 'APE'),
    ],
  },
  {
    objectID: 'T0156',
    subtitle: 'Token Price small name % change',
    frames: [
      cryptoFrameTemplate({ x: 654, y: 165 }, 'sm', 'ETH'),
      cryptoFrameTemplate({ x: 654, y: 255 }, 'sm', 'WBTC'),
      cryptoFrameTemplate({ x: 654, y: 345 }, 'sm', 'UNI'),
      cryptoFrameTemplate({ x: 654, y: 435 }, 'sm', 'MKR'),
      cryptoFrameTemplate({ x: 654, y: 525 }, 'sm', 'DAI'),
      cryptoFrameTemplate({ x: 654, y: 615 }, 'sm', 'USDC'),
    ],
  },
  {
    objectID: 'T0161',
    subtitle: 'Token Icons Price large symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 364, y: 150 }, 'lg', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 150 }, 'lg', 'WBTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 240 }, 'lg', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 240 }, 'lg', 'AAVE', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 330 }, 'lg', 'BAT', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 330 }, 'lg', 'LINK', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 420 }, 'lg', 'MKR', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 420 }, 'lg', 'YFI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 510 }, 'lg', 'COMP', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 510 }, 'lg', 'SNX', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 600 }, 'lg', 'DAI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 600 }, 'lg', 'USDC', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0162',
    subtitle: 'Token Icons Price small symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 547, y: 165 }, 'sm', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 165 }, 'sm', 'WBTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 255 }, 'sm', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 255 }, 'sm', 'AAVE', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 345 }, 'sm', 'BAT', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 345 }, 'sm', 'LINK', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 435 }, 'sm', 'MKR', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 435 }, 'sm', 'YFI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 525 }, 'sm', 'COMP', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 525 }, 'sm', 'SNX', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 615 }, 'sm', 'DAI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 615 }, 'sm', 'USDC', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0163',
    subtitle: 'Token Icons Price large name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 364, y: 150 }, 'lg', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 150 }, 'lg', 'WBTC', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 240 }, 'lg', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 240 }, 'lg', 'AAVE', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 330 }, 'lg', 'BAT', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 330 }, 'lg', 'LINK', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 420 }, 'lg', 'MKR', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 420 }, 'lg', 'YFI', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 510 }, 'lg', 'COMP', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 510 }, 'lg', 'SNX', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 600 }, 'lg', 'DAI', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 600 }, 'lg', 'USDC', { icon: true }),
    ],
  },
  {
    objectID: 'T0164',
    subtitle: 'Token Icons Price small name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 547, y: 165 }, 'sm', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 165 }, 'sm', 'WBTC', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 255 }, 'sm', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 255 }, 'sm', 'AAVE', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 345 }, 'sm', 'BAT', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 345 }, 'sm', 'LINK', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 435 }, 'sm', 'MKR', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 435 }, 'sm', 'YFI', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 525 }, 'sm', 'COMP', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 525 }, 'sm', 'SNX', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 615 }, 'sm', 'DAI', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 615 }, 'sm', 'USDC', { icon: true }),
    ],
  },
  {
    objectID: 'T0165',
    subtitle: 'Token Icons Price large symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 364, y: 150 }, 'lg', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 150 }, 'lg', 'BTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 240 }, 'lg', 'WBTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 240 }, 'lg', 'DOT', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 330 }, 'lg', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 330 }, 'lg', 'SUSHI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 420 }, 'lg', 'MKR', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 420 }, 'lg', 'XTZ', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 510 }, 'lg', 'DAI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 510 }, 'lg', 'DOGE', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 364, y: 600 }, 'lg', 'USDC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 744, y: 600 }, 'lg', 'ATOM', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0166',
    subtitle: 'Token Icons Price small symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 547, y: 165 }, 'sm', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 165 }, 'sm', 'BTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 255 }, 'sm', 'WBTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 255 }, 'sm', 'DOT', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 345 }, 'sm', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 345 }, 'sm', 'SUSHI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 435 }, 'sm', 'MKR', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 435 }, 'sm', 'XTZ', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 525 }, 'sm', 'DAI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 525 }, 'sm', 'DOGE', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 547, y: 615 }, 'sm', 'USDC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 732, y: 615 }, 'sm', 'ATOM', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0167',
    subtitle: 'Token Icons Price large name % change',
    frames: [
      cryptoFrameTemplate({ x: 364, y: 150 }, 'lg', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 150 }, 'lg', 'BTC', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 240 }, 'lg', 'WBTC', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 240 }, 'lg', 'DOT', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 330 }, 'lg', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 330 }, 'lg', 'SUSHI', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 420 }, 'lg', 'MKR', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 420 }, 'lg', 'XTZ', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 510 }, 'lg', 'DAI', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 510 }, 'lg', 'DOGE', { icon: true }),
      cryptoFrameTemplate({ x: 364, y: 600 }, 'lg', 'USDC', { icon: true }),
      cryptoFrameTemplate({ x: 744, y: 600 }, 'lg', 'ATOM', { icon: true }),
    ],
  },
  {
    objectID: 'T0168',
    subtitle: 'Token Icons Price small name % change',
    frames: [
      cryptoFrameTemplate({ x: 547, y: 165 }, 'sm', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 165 }, 'sm', 'BTC', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 255 }, 'sm', 'WBTC', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 255 }, 'sm', 'DOT', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 345 }, 'sm', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 345 }, 'sm', 'SUSHI', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 435 }, 'sm', 'MKR', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 435 }, 'sm', 'XTZ', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 525 }, 'sm', 'DAI', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 525 }, 'sm', 'DOGE', { icon: true }),
      cryptoFrameTemplate({ x: 547, y: 615 }, 'sm', 'USDC', { icon: true }),
      cryptoFrameTemplate({ x: 732, y: 615 }, 'sm', 'ATOM', { icon: true }),
    ],
  },
  {
    objectID: 'T0169',
    subtitle: 'Token Icons Price large symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 555, y: 150 }, 'lg', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 240 }, 'lg', 'WBTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 330 }, 'lg', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 420 }, 'lg', 'MKR', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 510 }, 'lg', 'DAI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 600 }, 'lg', 'USDC', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0170',
    subtitle: 'Token Icons Price small symbol % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 640, y: 165 }, 'sm', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 255 }, 'sm', 'WBTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 345 }, 'sm', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 435 }, 'sm', 'MKR', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 525 }, 'sm', 'DAI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 615 }, 'sm', 'USDC', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0171',
    subtitle: 'Token Icons Price large name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 555, y: 150 }, 'lg', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 240 }, 'lg', 'WBTC', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 330 }, 'lg', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 420 }, 'lg', 'MKR', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 510 }, 'lg', 'DAI', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 600 }, 'lg', 'USDC', { icon: true }),
    ],
  },
  {
    objectID: 'T0172',
    subtitle: 'Token Icons Price small name % change buy link',
    frames: [
      cryptoFrameTemplate({ x: 640, y: 165 }, 'sm', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 255 }, 'sm', 'WBTC', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 345 }, 'sm', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 435 }, 'sm', 'MKR', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 525 }, 'sm', 'DAI', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 615 }, 'sm', 'USDC', { icon: true }),
    ],
  },
  {
    objectID: 'T0173',
    subtitle: 'Token Icons Price large symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 555, y: 150 }, 'lg', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 240 }, 'lg', 'BTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 330 }, 'lg', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 420 }, 'lg', 'DOT', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 510 }, 'lg', 'XTZ', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 555, y: 600 }, 'lg', 'MKR', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0174',
    subtitle: 'Token Icons Price small symbol % change',
    frames: [
      cryptoFrameTemplate({ x: 640, y: 165 }, 'sm', 'ETH', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 255 }, 'sm', 'BTC', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 345 }, 'sm', 'UNI', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 435 }, 'sm', 'DOT', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 525 }, 'sm', 'XTZ', { symbol: true, icon: true }),
      cryptoFrameTemplate({ x: 640, y: 615 }, 'sm', 'MKR', { symbol: true, icon: true }),
    ],
  },
  {
    objectID: 'T0175',
    subtitle: 'Token Icons Price large name % change',
    frames: [
      cryptoFrameTemplate({ x: 555, y: 150 }, 'lg', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 240 }, 'lg', 'BTC', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 330 }, 'lg', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 420 }, 'lg', 'DOT', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 510 }, 'lg', 'XTZ', { icon: true }),
      cryptoFrameTemplate({ x: 555, y: 600 }, 'lg', 'MKR', { icon: true }),
    ],
  },
  {
    objectID: 'T0176',
    subtitle: 'Token Icons Price small name % change',
    frames: [
      cryptoFrameTemplate({ x: 640, y: 165 }, 'sm', 'ETH', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 255 }, 'sm', 'BTC', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 345 }, 'sm', 'UNI', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 435 }, 'sm', 'DOT', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 525 }, 'sm', 'XTZ', { icon: true }),
      cryptoFrameTemplate({ x: 640, y: 615 }, 'sm', 'MKR', { icon: true }),
    ],
  },
]

// https://www.notion.so/eboweb3/2629637071d04a8c8e7f3a68342b86df
const datasets = datasetTemplates.map((dataset) => {
  const id = dataset.objectID
  const frames = dataset.frames.map((template) => template())
  const descriptions = frames.map((frame, idx) => `${frame.fullName} - ${frame.description()}`)

  return {
    name: `Template - ${id}${dataset.subtitle ? ` - ${dataset.subtitle}` : ''}`,
    type: 'dataset',
    image: `/templates/${id}.png`,
    contentType: 'image/png',
    tags: [`${id.toLowerCase()}`, ...new Set(frames.flatMap((frame) => frame.tags()))],
    info: `Template ${id}\n\n${descriptions.join('\n\n')}`,
    ...dataset,
    get frames() {
      return dataset.frames.map((template) => template())
    },
  }
})
export default datasets

export const datasetInstance = (id) => {
  return datasets.find(({ objectID }) => objectID === id) || {}
}
